module.exports = __webpack_public_path__ + "img/bul_menu_export.aa0d9581.svg";